<div
  *transloco="let t; read: 'widgets.options'"
  class="xi-modal__container gauge-chart-options-dialog__container"
>
  <h2 class="xi-modal__title kxi-text-center">{{ t('chart-options') }}</h2>
  <form class="xi-modal__content gauge-chart-options-dialog__form" [formGroup]="form">
    <div class="gauge-chart-options-dialog__section">
      <div class="gauge-chart-options-dialog__section-header">{{ t('inner-number') }}</div>
      <div class="gauge-chart-options-dialog__section-content">
        <div class="gauge-chart-options-dialog__section">
          <div class="gauge-chart-options-dialog__section-sub-header">
            {{ t('metric-calculation') }}
          </div>
          <div class="gauge-chart-options-dialog__section-content">
            <div class="gauge-chart-options-dialog__metric-container">
              <div class="gauge-chart-options-dialog__metric-radios-container">
                <xi-radio
                  [label]="t('average')"
                  value="avg"
                  formControlName="metric"
                  name="metricRadio"
                  color="CX"
                ></xi-radio>
                <div class="gauge-chart-options-dialog__metric-box-radio-row">
                  <xi-radio
                    [label]="t('box')"
                    value="box"
                    formControlName="metric"
                    name="metricRadio"
                    color="CX"
                  ></xi-radio>
                  <xi-dropdown
                    select="single"
                    formControlName="metricBoxType"
                    [data]="boxTypeSet"
                    class="gauge-chart-options-dialog__box-type-dropdown"
                  ></xi-dropdown>
                  <xi-dropdown
                    select="single"
                    formControlName="metricBoxSize"
                    [data]="boxSizeSet"
                    class="gauge-chart-options-dialog__box-size-dropdown"
                  ></xi-dropdown>
                </div>
                <xi-radio
                  [label]="t('nps')"
                  value="nps"
                  formControlName="metric"
                  name="metricRadio"
                  color="CX"
                ></xi-radio>
              </div>
            </div>
            <div class="gauge-chart-options-dialog__rating-container">
              <div class="gauge-chart-options-dialog__min-rating-group">
                <label class="kxi-input-label">{{ t('minimum-rating') }}</label>
                <xi-toggle-switch
                  [leftText]="0"
                  [rightText]="1"
                  type="button"
                  formControlName="minRating"
                  [isToggled]="form.controls.minRating.value === 1"
                  (onToggle)="form.controls.minRating.setValue($event.detail.isToggled ? 1 : 0)"
                  color="CX"
                ></xi-toggle-switch>
              </div>
              <xi-input-field
                required
                [label]="t('maximum-rating')"
                formControlName="maxRating"
                type="number"
                [min]="2"
                [max]="1000"
              ></xi-input-field>
            </div>
            <xi-dropdown
              select="single"
              [label]="t('decimal-precision')"
              formControlName="decimalPrecision"
              [data]="decimalPrecisionSet"
              class="gauge-chart-options-dialog__decimal-precision-dropdown"
            ></xi-dropdown>
          </div>
        </div>
        <div class="gauge-chart-options-dialog__section">
          <div class="gauge-chart-options-dialog__section-sub-header">
            {{ t('comparison-options') }}
          </div>
          <div class="gauge-chart-options-dialog__section-content">
            <div class="gauge-chart-options-dialog__comparison-container">
              <div class="gauge-chart-options-dialog__comparison-label">{{ t('increase') }}:</div>
              @for (comparisonColorRadio of comparisonColorRadios; track comparisonColorRadio) {
                <xi-radio
                  [label]="comparisonColorRadio.label"
                  [value]="comparisonColorRadio.value"
                  formControlName="increaseColor"
                  name="increaseColorRadio"
                  color="CX"
                ></xi-radio>
              }
              <div class="gauge-chart-options-dialog__comparison-label">{{ t('decrease') }}:</div>
              @for (comparisonColorRadio of comparisonColorRadios; track comparisonColorRadio) {
                <xi-radio
                  [label]="comparisonColorRadio.label"
                  [value]="comparisonColorRadio.value"
                  formControlName="decreaseColor"
                  name="decreaseColorRadio"
                  color="CX"
                ></xi-radio>
              }
              <div class="gauge-chart-options-dialog__comparison-label">{{ t('show-as') }}</div>
              <xi-toggle-switch
                [leftText]="t('absolute')"
                [rightText]="t('percentage')"
                type="button"
                [isToggled]="form.controls.showAs.value === 'percentage'"
                (onToggle)="
                  form.controls.showAs.setValue($event.detail.isToggled ? 'percentage' : 'absolute')
                "
                color="CX"
                class="gauge-chart-options-dialog__comparison-toggle"
              ></xi-toggle-switch>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gauge-chart-options-dialog__separator"></div>

    <div class="gauge-chart-options-dialog__section">
      <div class="gauge-chart-options-dialog__section-header">{{ t('gauge-display') }}</div>

      <div class="gauge-chart-options-dialog__section-content">
        <div class="gauge-chart-options-dialog__section">
          <div class="gauge-chart-options-dialog__section-sub-header">
            {{ t('axis') }}
          </div>

          <div class="gauge-chart-options-dialog__section-content">
            <label class="kxi-input-label">{{ t('axis-values') }}</label>
            <xi-dropdown
              select="single"
              formControlName="axisValues"
              [data]="axisValues"
              class="gauge-chart-options-dialog__scoring-dropdown"
            ></xi-dropdown>

            <div class="gauge-chart-options-dialog__axis-values">
              <xi-input-field
                class="gauge-chart-options-dialog__input-field"
                formControlName="min"
                type="number"
                [label]="t('min')"
                [readOnly]="form.controls.axisValues.value === 'default'"
                [value]="minControl.value ?? undefined"
                (input)="onMinMaxValueChange($event.target.value, true)"
              ></xi-input-field>
              <xi-input-field
                class="gauge-chart-options-dialog__input-field"
                formControlName="max"
                type="number"
                [label]="t('max')"
                [readOnly]="form.controls.axisValues.value === 'default'"
                [value]="maxControl.value ?? undefined"
                (input)="onMinMaxValueChange($event.target.value, false)"
              ></xi-input-field>
            </div>
            @if (errorMessage) {
              <p class="error-message">
                <xi-icon icon="warning_filled" iconSize="small" color="error"></xi-icon>
                {{ errorMessage }}
              </p>
            }
          </div>
        </div>
      </div>
    </div>
  </form>

  <div class="xi-modal__actions gauge-chart-options-dialog__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>
    <xi-default-button
      [text]="t('apply')"
      [disabled]="form.invalid"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>
</div>
